export type PackSelectionValue = `legacy:${number}` | `pack:${number}`;

export const buildPackSelectionValue = (pack: {
  id: number;
  isLegacy: boolean;
}): PackSelectionValue =>
  pack.isLegacy ? `legacy:${pack.id}` : `pack:${pack.id}`;

export const parsePackSelectionValue = (
  value?: PackSelectionValue
): { packId?: number; packageId?: number } => {
  if (!value) {
    return {};
  }

  const [origin, rawId] = value.split(':');
  const id = Number(rawId);

  if (Number.isNaN(id)) {
    return {};
  }

  return origin === 'legacy' ? { packageId: id } : { packId: id };
};

export const buildPackSelectionValues = ({
  packageIds = [],
  packIds = [],
}: {
  packageIds?: number[];
  packIds?: number[];
}): PackSelectionValue[] => [
  ...packageIds.map((id) => buildPackSelectionValue({ id, isLegacy: true })),
  ...packIds.map((id) => buildPackSelectionValue({ id, isLegacy: false })),
];

export const splitPackSelectionValues = (
  values: (PackSelectionValue | undefined)[] = []
): { packageIds: number[]; packIds: number[] } =>
  values.reduce<{ packageIds: number[]; packIds: number[] }>(
    (acc, value) => {
      const { packageId, packId } = parsePackSelectionValue(value);

      if (packageId !== undefined) {
        acc.packageIds.push(packageId);
      }

      if (packId !== undefined) {
        acc.packIds.push(packId);
      }

      return acc;
    },
    { packageIds: [], packIds: [] }
  );
